import { Box, CircularProgress } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import React, { useState } from "react"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FilterCheckbox } from "@/components/common/Filters"
import { InputField } from "@/components/common/InputField"
import { DEBOUNCE_DELAY_MS } from "@/constants/common"
import useGetUsers from "@/screens/ChangeLog/hooks/useGetUsers"
import type { ChangeLogSearchFilters } from "@/screens/ChangeLog/stores/useChangeLogSearchStore"
import useDebounce from "@/utils/useDebounce"

interface ChangeLogUserFilterProps {
  onFilterChange: (name: keyof ChangeLogSearchFilters, value: unknown) => void
}

export const ChangeLogUserFilter: FC<ChangeLogUserFilterProps> = ({ onFilterChange }) => {
  const [searchTerm, setSearchTerm] = useState("")
  const { control, watch } = useFormContext()
  const usersValue = watch("userIds") || []
  const debouncedSearchString = useDebounce(searchTerm, DEBOUNCE_DELAY_MS)

  const { userList, fetching } = useGetUsers({ query: debouncedSearchString })

  const handleFilterChange = (newValue: string[]) => {
    onFilterChange("userIds", newValue)
  }

  return (
    <>
      <Box className='flex-none p-4'>
        <InputField
          placeholder='Search by Name'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          startAdornment={<SearchOutlined className='text-gray-600' />}
          endAdornment={fetching && <CircularProgress size={20} />}
        />
      </Box>

      <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
        {userList.map((user) => (
          <FilterCheckbox
            key={user.userId}
            label={user.name}
            value={user.userId}
            control={control}
            name='userIds'
            values={usersValue}
            onFilterChange={handleFilterChange}
          />
        ))}

        {fetching && (
          <Box display='flex' justifyContent='center' py={2}>
            <CircularProgress size={24} />
          </Box>
        )}
      </Box>
    </>
  )
}
